import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-50 via-cream-100 to-teal-50 flex flex-col items-center justify-center p-4 relative overflow-hidden">

      {/* Decorative background elements */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* Top-right radial glow */}
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-[radial-gradient(circle,rgba(196,117,76,0.08),transparent_70%)]" />
        {/* Bottom-left radial glow */}
        <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] bg-[radial-gradient(circle,rgba(90,123,111,0.06),transparent_70%)]" />

        {/* Subtle topographic lines */}
        <svg className="absolute inset-0 w-full h-full opacity-[0.03]" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="topo" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
              <path d="M 100 0 Q 125 50 100 100 Q 75 150 100 200" fill="none" stroke="#2C3E3D" strokeWidth="1" />
              <path d="M 0 100 Q 50 75 100 100 Q 150 125 200 100" fill="none" stroke="#2C3E3D" strokeWidth="1" />
              <circle cx="100" cy="100" r="60" fill="none" stroke="#2C3E3D" strokeWidth="0.5" />
              <circle cx="100" cy="100" r="40" fill="none" stroke="#2C3E3D" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#topo)" />
        </svg>

        {/* Mountain silhouette at bottom */}
        <svg className="absolute bottom-0 left-0 right-0 h-32 opacity-[0.04]" viewBox="0 0 1440 120" preserveAspectRatio="none">
          <path d="M0,120 L0,90 L120,50 L240,75 L360,30 L480,60 L600,15 L720,55 L840,25 L960,65 L1080,35 L1200,70 L1320,40 L1440,80 L1440,120 Z" fill="#2C3E3D" />
        </svg>
      </div>

      {/* Logo mark above card */}
      <div className="relative mb-6 flex flex-col items-center">
        <div className="w-12 h-12 bg-gradient-to-br from-charcoal-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg shadow-charcoal-500/20 mb-3">
          <span className="text-white font-bold text-lg">T</span>
        </div>
        <h2 className="text-xl font-bold text-charcoal-500 tracking-tight">Trailhead</h2>
        <p className="text-xs text-charcoal-300 mt-0.5">by Happy Camper Productions</p>
      </div>

      <div className="w-full max-w-md relative">
        <Outlet />
      </div>

      {/* Copyright Footer */}
      <div className="relative mt-8 text-center text-xs text-charcoal-300 space-y-1">
        <p>&copy; {new Date().getFullYear()} Happy Camper Productions. All rights reserved.</p>
        <div className="flex items-center justify-center gap-3">
          <a href="https://happycamperproductions.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-charcoal-500 underline transition-colors">Privacy Policy</a>
          <span className="text-charcoal-200">|</span>
          <a href="https://happycamperproductions.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="hover:text-charcoal-500 underline transition-colors">Terms of Service</a>
        </div>
      </div>
    </div>
  );
}
